import React, { ReactNode } from "react";
import { useLoosePermissionCheck } from "capitalrx-shell";
import { batchManualClaim } from "@/App/constants/permissions";
import PageContentLayout from "../PageContent";

interface Props {
  children: ReactNode;
  selected?: string;
}

const ManualClaimLayout: React.FC<Props> = (props: Props) => {
  const { children, selected = "leftToggle" } = props;
  const sectionTitle = "DMR/Manual Claim Adjudication";

  return (
    <PageContentLayout
      showToggleButton={useLoosePermissionCheck(batchManualClaim)}
      leftToggleURL="/manual-claim"
      rightToggleURL="/manual-claim/batch"
      leftToggleContent="Single"
      rightToggleContent="Batch"
      leftToggleSelected={selected === "leftToggle"}
      rightToggleSelected={selected === "rightToggle"}
      title={sectionTitle}
      pageContentHeaderClassName="manual-claim-page-header"
    >
      {children}
    </PageContentLayout>
  );
};

export default ManualClaimLayout;
